export interface ActivationPositioningCopy {
  readonly headline: string;
  readonly body: string;
}

export const ACTIVATION_POSITIONING_COPY: ActivationPositioningCopy = {
  headline: 'You just designed an operating model that needs a chassis.',
  body:
    'Every seat needs one place where customer data, conversations, opportunities, ' +
    'and decisions live — otherwise each role works blind. VibeControl is that ' +
    'chassis: the data layer your operating model runs on, with your ' +
    'workforce wired in. Without it, you\'d spend the next ' +
    '6 months bolting integrations onto disconnected tools. With it, your team is ' +
    'running in under a minute.',
} as const;
